import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var container = document.getElementById("retainable-rss-embed");
    if (container) {
        var css = document.createElement('link');
        css.href = "https://www.twilik.com/assets/retainable/rss-embed/retainable.css";
        css.rel = "stylesheet"
        document.getElementsByTagName('head')[0].appendChild(css);
        var script = document.createElement('script');
        script.src = "https://www.twilik.com/assets/retainable/rss-embed/retainable-rss-embed.js";
        document.getElementsByTagName('body')[0].appendChild(script);
    }
  }

}
